import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Container } from '@material-ui/core';
import Page from 'src/components/Page';
import Header from 'src/components/Header';
import Todos from './Todos';
import { getWarehouseProductRequest } from '../../store/actions/warehouseProductActions';
import { connect } from 'react-redux';
import CircularProgressDepoTakip from '@material-ui/core/CircularProgress';
import { PullToRefresh } from "react-js-pull-to-refresh";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }
}));

function DepoTakip(props) {
  const today = new Date();
  const todayString = today.toLocaleDateString().split('/').join('.');
  const getWarehouseProducts = (startDate = todayString, endDate = todayString) => {
    props.getWarehouseProductRequest(startDate, endDate);
  }

  useEffect(() => {
    getWarehouseProducts();
    // eslint-disable-next-line
  }, []);

  const onRefreshDepoTakip = () => {
    return new Promise((resolve) => {
      setTimeout(resolve, 50);
      getWarehouseProducts();
    });
  }


  const classes = useStyles();
  return (
    <Page className={classes.root} title="Depo Takip">
      <Container maxWidth="lg">
        <Header />
        <PullToRefresh
          pullDownContent={<CircularProgressDepoTakip status={'loading'} style={{ marginLeft: '45%' }} />}
          releaseContent={<CircularProgressDepoTakip status={'loading'} style={{ marginLeft: '45%' }} />}
          refreshContent={<CircularProgressDepoTakip status={'loading'} style={{ marginLeft: '45%' }} />}
          pullDownThreshold={100}
          onRefresh={onRefreshDepoTakip}
          triggerHeight={500}
          startInvisible={true}
        >
          <div style={{ minHeight: 400, textAlign: 'center' }}>
            <Todos className={classes.todos} getWarehouseProducts={getWarehouseProducts} />
          </div>
        </PullToRefresh>
      </Container>
    </Page>
  );
}

export default connect(
  state => state,
  {
    getWarehouseProductRequest
  }
)(DepoTakip);
